import {createStore, applyMiddleware } from "redux";
import createSagaMiddleware from 'redux-saga';
import createHistory from 'history/createBrowserHistory';
import RootSaga from "../utils/rootSaga";
import rootReducer from '../utils/rootReducer';
import { composeWithDevTools } from 'redux-devtools-extension';

const initialState = {};

const sagaMiddleware = createSagaMiddleware();
export const history = createHistory();
export const store = createStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(sagaMiddleware, )));
sagaMiddleware.run(RootSaga);



// WEBPACK FOOTER //
// ./src/utils/store.js